import { CustomCollapseCard, Text, CustomImage, AddCarTypeSkeleton } from '@src/components';
import { Radio, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSelectVehicleDeviceType,
  setSelectVehicleDeviceTypeList,
} from '@src/store/slice/addNewCarStore/addCarTypeSlice';
import iconBilgiSvg from '@src/assets/icons/icon-bilgi.svg';
import iconcircleSvg from '@src/assets/icons/info-circle.svg';
import '@src/styles/addNewCar/addCarSelectType.scss';
import { warningDialog } from '@src/components/CustomDialog';

const AddCarSelectType = ({ vehicleDeviceTypeList }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const selectedDeviceType = useSelector((state) => state.addCarType.selectVehicleDeviceType);
  const [value, setValue] = useState(selectedDeviceType ?? null);
  const [iframeKey, setIframeKey] = useState(0);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.addCarType.loading.vehicleDeviceTypeList);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUTTSModalVisible, setIsUTTSModalVisible] = useState(false);

  const showModal = (val) => {
    if (val === 18) {
      setIsUTTSModalVisible(true);
    } else {
      setIsModalVisible(true);
    }
  };

  const handleCarSelectTypeChanged = (e) => {
    const newValue = e.target.value;
    const selectVehicleDeviceTypeList = vehicleDeviceTypeList.find(
      (list) => list.deviceTypeId === newValue,
    );
    setValue(newValue);
    dispatch(setSelectVehicleDeviceType(newValue));
    dispatch(setSelectVehicleDeviceTypeList(selectVehicleDeviceTypeList));
  };

  useEffect(() => {
    if (isUTTSModalVisible) {
      warningDialog({
        title: (
          <div className="utts-modal-1-head">
            <span className="utts-modal-1-head-text">
              <Text t="uttsInformation" />
            </span>
          </div>
        ),
        customWarnIcon: true,
        width: 580,
        onCancel: () => {
          setIsUTTSModalVisible(false);
        },
        onOk: () => {
          setIsUTTSModalVisible(false);
        },
        className: 'warningModal-utts not-show-warning-buttons',
        okButtonProps: 'not-show-warning-buttons',
        htmlContent: (
          <div>
            <div className="utts-modal-1-area1">
              <span className="utts-modal-1-area1-text">
                <Text t="accordingToTheRegulationOfTheRevenueAdministration" />{' '}
                <b className="utts-bold">
                  <Text t="mandatory" />
                </b>{' '}
                <Text t="hasArrived" />
              </span>{' '}
            </div>
            <div style={{ display: 'flex', marginTop: 20 }}>
              <span className="utts-modal-1-area1-text">
                <Text t="theDeadlineSetForVehicleIdentificationUnitTtb" />{' '}
                <b className="utts-bold">
                  <Text t="june302025" />
                </b>{' '}
                <Text t="hasBeenUpdatedAsAsOfThisDate" />{' '}
                <b className="utts-bold">
                  {' '}
                  <Text t="willNotBeAbleToBenefitFromTax" />
                </b>{' '}
                <Text t="willBeSubjectTo" />
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                marginTop: 50,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <a
                href="https://www.utts.gov.tr"
                target="_blank"
                className="utts-modal-1-area1-footer"
              >
                <Text t="clickForDetailedInformationAboutUtts" />
              </a>
            </div>
          </div>
        ),
      });
    }
  }, [isUTTSModalVisible]);

  return (
    <CustomCollapseCard
      className="add-car-select-type-collapse"
      bodyCenter={!isMobil}
      cardTitle={<Text t="selectDeviceType" />}
      cardTitleAlign="center"
    >
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <div className="for-utts-area">
          <CustomImage src={iconcircleSvg} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="for-utts-head">
              <Text t="importantInformation" />
            </span>
            <span className="for-utts-text">
              <Text t="allVehiclesOwnedByOrLeasedToCompanies" />{' '}
              <b className="utts-bold">
                <Text t="commercialVehicles" />
              </b>{' '}
              <Text t="for" />{' '}
              <b className="utts-bold">
                <Text t="uttsTransitionIsMandatory" />
              </b>{' '}
              <Text t="hasBecomeInOrderToContinueToBenefit" />{' '}
              <b className="utts-bold">
                <Text t="completeYourUttsDeviceAssemblyOperationsByJune" />
              </b>{' '}
              <Text t="weRemindYouThatYouNeedToComplete" />{' '}
            </span>
            <a
              href="https://www.utts.gov.tr/"
              target="_blank"
              className="for-utts-text"
              style={{ textDecoration: 'underline' }}
            >
              <Text t="clickForDetailedInformation" />{' '}
            </a>
          </div>
        </div>

        {loading ? (
          <AddCarTypeSkeleton />
        ) : (
          <Radio.Group
            id="ticket-car-select-type-content"
            onChange={handleCarSelectTypeChanged}
            value={value}
            className="add-car-select-type-content"
          >

            {vehicleDeviceTypeList
              ?.filter((item) => item.deviceTypeId !== 2)
              ?.map((device) => (
                <Radio
                  id={`ticketcardevice-${device.deviceTypeId}`}
                  value={device.deviceTypeId}
                  key={device.deviceTypeId}
                  aria-label={device.deviceTypeLabel}
                >
                  <div className="new-order-draft">
                    <Text t={device.deviceTypeLabel} />
                    {(device.deviceTypeId === 17 || device.deviceTypeId === 18) && (
                      <>
{/*<Badge
style={{ padding: '0 12px 2px 12px' }}
                        count={'yeni'}
                        offset={[10, 0]}
                      />*/}
                        <CustomImage
                          style={{
                            padding: '3px 10px 3px 8px',
                            height: '25px',
                            cursor: 'pointer',
                          }}
                          src={iconBilgiSvg}
                          alt="icon-bilgi"
                          onClick={() => showModal(device.deviceTypeId)}
                        />
                      </>
                    )}
                  </div>
                </Radio>
              ))}
          </Radio.Group>
        )}
      </div>

      <Modal
        visible={isModalVisible}
        footer={null}
        onCancel={() => {
          setIsModalVisible(false);
          setIframeKey((prevKey) => prevKey + 1);
        }}
      >
        {isModalVisible && (
          <iframe
            key={iframeKey}
            width={isMobil ? '340' : '460'}
            height="260"
            tabIndex={-1}
            title="Mobil Uygulama"
            src="https://www.youtube-nocookie.com/embed/To9MhLFWgLE"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen=""
            style={{ marginTop: 20 }}
          ></iframe>
        )}
      </Modal>
    </CustomCollapseCard>
  );
};

AddCarSelectType.propTypes = {
  vehicleDeviceTypeList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AddCarSelectType;
